import { IDENTITIES_KEYS } from '../../types';
import { getConsent, listenToCmpDialogEvents } from './consent';
import { getBadgeFromDot, getLogin, listenToBadge } from './login';
import { getUdid, listenToMarker } from './udid';
import { getSid, listenToSidEvents } from './sid';
import { isAvailable } from '../config';
import { getSecid, listenToSecId } from './secid';
import { getTopLevelInfo } from '../frames';
import { TIMEOUT_PREMATURE_LOGIN } from '../consts';
import { fetchId5 } from './id5';
/**
 * Pull identities in sync way (from cookies, ...)
 */
export const pullExternalsSync = (identities) => {
    // consent
    isAvailable(IDENTITIES_KEYS.consent) && getConsent(identities);
    // login
    isAvailable(IDENTITIES_KEYS.login) && getLogin(identities);
    // udid
    isAvailable(IDENTITIES_KEYS.udid) && getUdid(identities);
    // sid
    isAvailable(IDENTITIES_KEYS.sid) && getSid(identities);
    // secid
    isAvailable(IDENTITIES_KEYS.secid) && getSecid(identities);
};
/**
 * Pull identities in async way (from events, messages,...)
 */
export const pullExternalsAsync = (initObject, updater, getter, awaiter) => {
    const getterSpecified = (identificator) => {
        return getter()[identificator] || initObject[identificator];
    };
    // consent
    isAvailable(IDENTITIES_KEYS.consent) && listenToCmpDialogEvents(updater, getterSpecified);
    // login
    isAvailable(IDENTITIES_KEYS.login) && listenToBadge(updater, getterSpecified);
    // udid
    isAvailable(IDENTITIES_KEYS.udid) && listenToMarker(updater, getterSpecified);
    // sid
    isAvailable(IDENTITIES_KEYS.sid) && listenToSidEvents(updater, getterSpecified);
    // secid
    isAvailable(IDENTITIES_KEYS.secid) && listenToSecId(updater, getterSpecified);
    // id5
    isAvailable(IDENTITIES_KEYS.id5) && fetchId5(updater, getterSpecified, awaiter);
};
/**
 * Optional callbacks for "early settling"
 * For example after 1s there is no window.login.current object -> we can asume SZN badge is not in page
 */
export const prematureSettling = {
    [IDENTITIES_KEYS.login]: (cb) => {
        return window.setTimeout(() => {
            // run premature callback
            if (!getBadgeFromDot() && !getTopLevelInfo().hasLoginBadge) {
                return cb(null);
            }
        }, TIMEOUT_PREMATURE_LOGIN);
    },
};
